export default __webpack_public_path__ + "static/playstore_download-78868e945411dfba69a117ed4c6ea35b.svg";